export const Urls = {
    preRoll: "https://vimeo.com/481775576",
    paused: "https://vimeo.com/483438735",
}